export const LCOptions = [
	{ value: 'abuja', label: 'Abuja' },
	{ value: 'abia', label: 'Abia' },
	{ value: 'adawama', label: 'Adamawa' },
	{ value: 'akwa-ibom', label: 'Akwa Ibom' },
	{ value: 'anambra', label: 'Anambra' },
	{ value: 'bauchi', label: 'Bauchi' },
	{ value: 'bayelsa', label: 'Bayelsa' },
	{ value: 'benue', label: 'Benue' },
	{ value: 'borno', label: 'Borno' },
	{ value: 'cross-river', label: 'Cross River' },
	{ value: 'delta', label: 'Delta' },
	{ value: 'ebonyi', label: 'Ebonyi' },
	{ value: 'edo', label: 'Edo' },
	{ value: 'ekiti', label: 'Ekiti' },
	{ value: 'enugu', label: 'Enugu' },
	{ value: 'gombe', label: 'Gombe' },
	{ value: 'imo', label: 'Imo' },
	{ value: 'jigawa', label: 'Jigawa' },
	{ value: 'kaduna', label: 'Kaduna' },
	{ value: 'kano', label: 'Kano' },
	{ value: 'katsina', label: 'Katsina' },
	{ value: 'kebbi', label: 'Kebbi' },
	{ value: 'kogi', label: 'Kogi' },
	{ value: 'kwara', label: 'Kwara' },
	{ value: 'lagos', label: 'Lagos' },
	{ value: 'nasarawa', label: 'Nasarawa' },
	{ value: 'niger', label: 'Niger' },
	{ value: 'ogun', label: 'Ogun' },
	{ value: 'ondo', label: 'Ondo' },
	{ value: 'osun', label: 'Osun' },
	{ value: 'oyo', label: 'Oyo' },
	{ value: 'plateau', label: 'Plateau' },
	{ value: 'rivers', label: 'Rivers' },
	{ value: 'sokoto', label: 'Sokoto' },
	{ value: 'taraba', label: 'Taraba' },
	{ value: 'yobe', label: 'Yobe' },
	{ value: 'zamfara', label: 'Zamfara' },
];

export const ageOptions = [
	{ value: '< 18', label: '< 18' },
	{ value: '18-24', label: '18-24' },
	{ value: '24-28', label: '24-28' },
	{ value: '28+', label: '28+' },
];

export const SDGOptions = [
	{
		value: 'SDG 9',
		label: 'SDG 9 - Industry, Innovation, and Infrastructure',
	},
	{
		value: 'SDG 12',
		label: 'SDG 12 - Responsible Consumption and Production',
	},
	{
		value: 'SDG 13',
		label: 'SDG 13 - Climate Action',
	},
];

export const attendanceOptions = [
	{ value: 'physical', label: 'Physical' },
	{ value: 'virtual', label: 'Virtual' },
];

export const yesNoOptions = [
	{ value: 'yes', label: 'Yes' },
	{ value: 'no', label: 'No' },
];

export const contactOptions = [
	{ value: 'phone', label: 'Phone call' },
	{ value: 'text', label: 'Text' },
	{ value: 'whatsapp', label: 'Whatsapp' },
	{ value: 'email', label: 'Email' },
];

export const referralOptions = [
	{ value: 'friend', label: 'Friend' },
	{ value: 'email', label: 'Email' },
	{ value: 'event', label: 'Event' },
	{ value: 'facebook', label: 'Facebook' },
	{ value: 'instagram', label: 'Instagram' },
	{ value: 'whatsapp', label: 'Whatsapp' },
	{ value: 'other Social Media channel', label: 'Other Social Media channel' },
];

export const academicOptions = [
	{ value: '100', label: '100' },
	{ value: '200', label: '200' },
	{ value: '300', label: '300' },
	{ value: '400', label: '400' },
	{ value: '500', label: '500' },
	{ value: '600', label: '600' },
	{ value: 'graduate', label: 'Graduate' },
	{ value: 'others', label: 'Others' },
];

export const employmentStatusOptions =
	[
		{ value: 'student', label: 'Student' },
		{ value: 'self-employed', label: 'Self-employed' },
		{ value: 'employed', label: 'Employed' },
		{ value: 'unemployed', label: 'Unemployed' },
	];

export const shirtSizeOptions = [
	{
		value: 'Small',
		label: 'Small(S)',
	},
	{ value: 'Medium', label: 'Medium(M)' },
	{ value: 'Large', label: 'Large(L)' },
	{ value: 'Extra Large', label: 'Extra Large(XL)' },
];
